import React, { useContext, useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import "./topnavbar.scss";
import {
  Avatar,
  IconButton,
  Button,
  Stack,
  Toolbar,
  Box,
  Typography,
  Tooltip,
  Menu,
  MenuItem,
} from "@mui/material";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import ArrowDropUpIcon from "@mui/icons-material/ArrowDropUp";
import MenuIcon from "@mui/icons-material/Menu";
import { AuthContext } from "../Context/AuthContext";
import { translateLauguage } from "../Function/Translate";

import { LogoutDialog } from "./LogoutDialog";

// logo or pic
import logo from "../Assets/it-logo.png";
import CamFlag from "../Assets/Cambodia.png";
import EngFlag from "../Assets/United_Kingdom.png";

// icon
import { FaComputer } from "react-icons/fa6";
import { GiTakeMyMoney } from "react-icons/gi";
import DescriptionIcon from "@mui/icons-material/Description";
import AssessmentIcon from "@mui/icons-material/Assessment";
import WarehouseIcon from "@mui/icons-material/Warehouse";
import SettingsIcon from "@mui/icons-material/Settings";

export default function TopNavbarMobile({ handleDrawerOpen }) {
  const navigate = useNavigate();

  // ===================== Change Language ==========================
  const { language, changeLanguage } = useContext(AuthContext);
  const { t } = translateLauguage(language);

  let userLogin = JSON.parse(window.localStorage.getItem("logIn"));

  // ======================= Change language function =======================
  const [langauge, setLanguage] = useState(
    JSON.parse(window.localStorage.getItem("language"))
  );
  const handleChangeLanguage = (lang) => {
    window.localStorage.setItem("language", JSON.stringify(lang));
    setLanguage(lang);
    changeLanguage(lang);
  };

  useEffect(() => {
    async function checkLanguage() {
      let userLanguage = await JSON.parse(
        window.localStorage.getItem("language")
      );
      if (userLanguage) {
        setLanguage(userLanguage);
        return;
      } else {
        setLanguage("kh");
      }
    }
    checkLanguage();
  }, []);

  // ============== log out ============
  // ================== Function menu logout ===================
  const [anchorEl, setAnchorEl] = useState(null);
  const openMenu = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  // ================== Function open logout ===================
  const [oepnLogout, setOpenLogout] = useState(false);
  const handleOpenLogout = () => {
    setOpenLogout(true);
    handleClose();
  };
  const handleCloseLogout = () => {
    setOpenLogout(false);
  };

  return (
    <Toolbar className="top-navbar-style">
      <Stack
        direction="row"
        sx={{ width: "100%" }}
        justifyContent={`center`}
        alignItems={`center`}
        spacing={2}
      >
        <IconButton
          color="inherit"
          aria-label="open drawer"
          onClick={() => handleDrawerOpen()}
          edge="start"
          sx={{ mr: 2 }}
        >
          <MenuIcon sx={{ color: "#158843", fontSize: "30px" }} />
        </IconButton>

        <Box sx={{ flexGrow: 1 }} />

        <Stack
          direction="row"
          spacing={2}
          justifyContent="right"
          alignContent={`center`}
        >
          <Stack direction="column" justifyContent="center">
            {language === "en" ? (
              <Tooltip title="Change to Khmer" placement="left">
                <IconButton onClick={() => changeLanguage("kh")}>
                  <Avatar
                    src={EngFlag}
                    sx={{ width: "30px", height: "30px" }}
                  />
                </IconButton>
              </Tooltip>
            ) : (
              <Tooltip title="Change to English" placement="left">
                <IconButton onClick={() => changeLanguage("en")}>
                  <Avatar
                    src={CamFlag}
                    sx={{ width: "30px", height: "30px" }}
                  />
                </IconButton>
              </Tooltip>
            )}
          </Stack>
          <Stack direction="column" justifyContent="center">
            <Button className="btn-menu" onClick={handleClick}>
              <Stack direction="row" spacing={2}>
                <Stack direction="column" textAlign="left">
                  <Typography
                    className={
                      language === "en" ? "username-text" : "username-text-kh"
                    }
                  >
                    {userLogin
                      ? langauge === "en"
                        ? userLogin?.latin_name
                        : userLogin?.last_name + " " + userLogin?.first_name
                      : "NO User"}
                  </Typography>
                  <Typography
                    className={language === "en" ? "role-text" : "role-text-kh"}
                  >
                    {userLogin ? userLogin?.role : "NO Role"}
                  </Typography>
                </Stack>
                <Stack direction="column" justifyContent="center">
                  {openMenu ? (
                    <ArrowDropUpIcon className="icon-menu" />
                  ) : (
                    <ArrowDropDownIcon className="icon-menu" />
                  )}
                </Stack>
              </Stack>
            </Button>

            <Menu
              anchorEl={anchorEl}
              id="account-menu"
              open={openMenu}
              onClose={handleClose}
              onClick={handleClose}
              // PaperProps={{
              //   elevation: 0,
              //   sx: {
              //     overflow: "visible",
              //     filter: "drop-shadow(0px 2px 8px rgba(0,0,0,0.32))",
              //     mt: 1.5,
              //     "& .MuiAvatar-root": {
              //       width: 32,
              //       height: 32,
              //       ml: -0.5,
              //       mr: 1,
              //     },
              //     "&:before": {
              //       content: '""',
              //       display: "block",
              //       position: "absolute",
              //       top: 0,
              //       right: 14,
              //       width: 10,
              //       height: 10,
              //       bgcolor: "background.paper",
              //       transform: "translateY(-50%) rotate(45deg)",
              //       zIndex: 0,
              //     },
              //   },
              // }}
              transformOrigin={{ horizontal: "right", vertical: "top" }}
              anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
            >
              <MenuItem onClick={handleOpenLogout}>
                <Typography className="log-out-txt">{t("log_out")}</Typography>
              </MenuItem>
            </Menu>

            <LogoutDialog open={oepnLogout} handleClose={handleCloseLogout} />
          </Stack>
        </Stack>
      </Stack>
    </Toolbar>
  );
}
